import { clsx } from 'clsx';

import { Slider } from '@monoimin/atoms/components/Slider';

import { RangeInput } from '@monoimin/molecules/inputs/RangeInput';

import { RangeProps } from '../types';

export const Range = ({
  value,
  onChange,
  min,
  max,
  classNames,
  onMouseUp,
  onKeyDown,
  step,
  hideSlider,
  hideInput,
  fromPlaceholder,
  toPlaceholder,
}: RangeProps) => {
  return (
    <div className={clsx('flex flex-col gap-8', classNames?.container)}>
      {!hideInput && (
        <RangeInput
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          min={min}
          max={max}
          className={classNames?.input}
          fromPlaceholder={fromPlaceholder}
          toPlaceholder={toPlaceholder}
        />
      )}
      {!hideSlider && (
        <Slider
          value={value}
          onChange={onChange}
          min={min}
          max={max}
          onMouseUp={onMouseUp}
          step={step}
          className={classNames?.slider}
        />
      )}
    </div>
  );
};
